import { Component, inject, input, Input } from '@angular/core';
import { BuildingItemDto } from '@artemis-software/wr-api';
import { Router } from '@angular/router';
import { Tracked } from '@/utils/signals/tracked';

@Component({
  standalone: false,
  selector: 'wr-building-badge',
  templateUrl: './building-badge.component.html',
  styleUrls: ['./building-badge.component.scss']
})
export class BuildingBadgeComponent {
  readonly router = inject(Router);

  readonly building = input.required<BuildingItemDto>();

  @Input()
  @Tracked()
  disableLink = false;
}
